export default {
    email:    'email',
    password: 'password',
    text:     'text',
    textarea: 'textarea',
};
